import { AssetSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import SimpleBreadcrumbs from "Components/Shared/SimpleBreadcrumbs";
import { Field, Formik } from "formik";
import { useAsset } from "Hooks/Endpoints";
import React from "react";
import { Container, Divider, Form, Header, Segment } from "semantic-ui-react";
import FileViewer from "react-file-viewer";

const AssetEditForm = () => {
  const { update, asset, unselect, remove } = useAsset();
  return (
    <Container fluid>
      <SimpleBreadcrumbs title='Assets' subtitle='Edit' onBack={unselect} />

      <Segment>
        <Header as='h3'>Edit Asset</Header>
        <Divider />
        <Formik
          initialValues={asset}
          validationSchema={AssetSchema}
          onSubmit={(values, actions) => {
            update(values);
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Segment>
                <FileViewer
                  fileType={asset.mimeType.split("/")[1]}
                  filePath={asset.publicURL}
                  errorComponent={<span>Error</span>}
                />
                <br />
              </Segment>

              <Field name='name' label='name' component={CallableInput} />

              <FormSubmit
                name='Update Asset'
                errors={props.errors}
                onCancel={unselect}
                onDelete={remove}
              />
            </Form>
          )}
        </Formik>
      </Segment>
    </Container>
  );
};

export default AssetEditForm;
